import * as C from "react";
import $, { createContext as dt, useContext as gt, useEffect as mt } from "react";
import { g as bt } from "./_commonjsHelpers-C6fGbg64.js";
var U = /* @__PURE__ */ dt({});
function M() {
  return M = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var r in e) ({}).hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }
    return n;
  }, M.apply(null, arguments);
}
function yt(n) {
  if (Array.isArray(n)) return n;
}
function pt(n, t) {
  var e = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (e != null) {
    var r, i, o, s, a = [], c = !0, u = !1;
    try {
      if (o = (e = e.call(n)).next, t === 0) {
        if (Object(e) !== e) return;
        c = !1;
      } else for (; !(c = (r = o.call(e)).done) && (a.push(r.value), a.length !== t); c = !0) ;
    } catch (l) {
      u = !0, i = l;
    } finally {
      try {
        if (!c && e.return != null && (s = e.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return a;
  }
}
function L(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var e = 0, r = Array(t); e < t; e++) r[e] = n[e];
  return r;
}
function vt(n, t) {
  if (n) {
    if (typeof n == "string") return L(n, t);
    var e = {}.toString.call(n).slice(8, -1);
    return e === "Object" && n.constructor && (e = n.constructor.name), e === "Map" || e === "Set" ? Array.from(n) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? L(n, t) : void 0;
  }
}
function Ct() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y(n, t) {
  return yt(n) || pt(n, t) || vt(n, t) || Ct();
}
function b(n) {
  "@babel/helpers - typeof";
  return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, b(n);
}
function xt(n, t) {
  if (b(n) != "object" || !n) return n;
  var e = n[Symbol.toPrimitive];
  if (e !== void 0) {
    var r = e.call(n, t);
    if (b(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(n);
}
function _t(n) {
  var t = xt(n, "string");
  return b(t) == "symbol" ? t : t + "";
}
function d(n, t, e) {
  return (t = _t(t)) in n ? Object.defineProperty(n, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = e, n;
}
function St(n, t) {
  if (n == null) return {};
  var e = {};
  for (var r in n) if ({}.hasOwnProperty.call(n, r)) {
    if (t.indexOf(r) !== -1) continue;
    e[r] = n[r];
  }
  return e;
}
function J(n, t) {
  if (n == null) return {};
  var e, r, i = St(n, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    for (r = 0; r < o.length; r++) e = o[r], t.indexOf(e) === -1 && {}.propertyIsEnumerable.call(n, e) && (i[e] = n[e]);
  }
  return i;
}
var X = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(n) {
  (function() {
    var t = {}.hasOwnProperty;
    function e() {
      for (var o = "", s = 0; s < arguments.length; s++) {
        var a = arguments[s];
        a && (o = i(o, r(a)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return e.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var s = "";
      for (var a in o)
        t.call(o, a) && o[a] && (s = i(s, a));
      return s;
    }
    function i(o, s) {
      return s ? o ? o + " " + s : o + s : o;
    }
    n.exports ? (e.default = e, n.exports = e) : window.classNames = e;
  })();
})(X);
var wt = X.exports;
const Tt = /* @__PURE__ */ bt(wt), h = Math.round;
function O(n, t) {
  const e = n.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], r = e.map((i) => parseFloat(i));
  for (let i = 0; i < 3; i += 1)
    r[i] = t(r[i] || 0, e[i] || "", i);
  return e[3] ? r[3] = e[3].includes("%") ? r[3] / 100 : r[3] : r[3] = 1, r;
}
const D = (n, t, e) => e === 0 ? n : n / 100;
function v(n, t) {
  const e = t || 255;
  return n > e ? e : n < 0 ? 0 : n;
}
class y {
  constructor(t) {
    d(this, "isValid", !0), d(this, "r", 0), d(this, "g", 0), d(this, "b", 0), d(this, "a", 1), d(this, "_h", void 0), d(this, "_s", void 0), d(this, "_l", void 0), d(this, "_v", void 0), d(this, "_max", void 0), d(this, "_min", void 0), d(this, "_brightness", void 0);
    function e(r) {
      return r[0] in t && r[1] in t && r[2] in t;
    }
    if (t) if (typeof t == "string") {
      let i = function(o) {
        return r.startsWith(o);
      };
      const r = t.trim();
      /^#?[A-F\d]{3,8}$/i.test(r) ? this.fromHexString(r) : i("rgb") ? this.fromRgbString(r) : i("hsl") ? this.fromHslString(r) : (i("hsv") || i("hsb")) && this.fromHsvString(r);
    } else if (t instanceof y)
      this.r = t.r, this.g = t.g, this.b = t.b, this.a = t.a, this._h = t._h, this._s = t._s, this._l = t._l, this._v = t._v;
    else if (e("rgb"))
      this.r = v(t.r), this.g = v(t.g), this.b = v(t.b), this.a = typeof t.a == "number" ? v(t.a, 1) : 1;
    else if (e("hsl"))
      this.fromHsl(t);
    else if (e("hsv"))
      this.fromHsv(t);
    else
      throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(t));
  }
  // ======================= Setter =======================
  setR(t) {
    return this._sc("r", t);
  }
  setG(t) {
    return this._sc("g", t);
  }
  setB(t) {
    return this._sc("b", t);
  }
  setA(t) {
    return this._sc("a", t, 1);
  }
  setHue(t) {
    const e = this.toHsv();
    return e.h = t, this._c(e);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function t(o) {
      const s = o / 255;
      return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    }
    const e = t(this.r), r = t(this.g), i = t(this.b);
    return 0.2126 * e + 0.7152 * r + 0.0722 * i;
  }
  getHue() {
    if (typeof this._h > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._h = 0 : this._h = h(60 * (this.r === this.getMax() ? (this.g - this.b) / t + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / t + 2 : (this.r - this.g) / t + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._s = 0 : this._s = t / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(t = 10) {
    const e = this.getHue(), r = this.getSaturation();
    let i = this.getLightness() - t / 100;
    return i < 0 && (i = 0), this._c({
      h: e,
      s: r,
      l: i,
      a: this.a
    });
  }
  lighten(t = 10) {
    const e = this.getHue(), r = this.getSaturation();
    let i = this.getLightness() + t / 100;
    return i > 1 && (i = 1), this._c({
      h: e,
      s: r,
      l: i,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(t, e = 50) {
    const r = this._c(t), i = e / 100, o = (a) => (r[a] - this[a]) * i + this[a], s = {
      r: h(o("r")),
      g: h(o("g")),
      b: h(o("b")),
      a: h(o("a") * 100) / 100
    };
    return this._c(s);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(t = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, t);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(t = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, t);
  }
  onBackground(t) {
    const e = this._c(t), r = this.a + e.a * (1 - this.a), i = (o) => h((this[o] * this.a + e[o] * e.a * (1 - this.a)) / r);
    return this._c({
      r: i("r"),
      g: i("g"),
      b: i("b"),
      a: r
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(t) {
    return this.r === t.r && this.g === t.g && this.b === t.b && this.a === t.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let t = "#";
    const e = (this.r || 0).toString(16);
    t += e.length === 2 ? e : "0" + e;
    const r = (this.g || 0).toString(16);
    t += r.length === 2 ? r : "0" + r;
    const i = (this.b || 0).toString(16);
    if (t += i.length === 2 ? i : "0" + i, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const o = h(this.a * 255).toString(16);
      t += o.length === 2 ? o : "0" + o;
    }
    return t;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const t = this.getHue(), e = h(this.getSaturation() * 100), r = h(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${t},${e}%,${r}%,${this.a})` : `hsl(${t},${e}%,${r}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(t, e, r) {
    const i = this.clone();
    return i[t] = v(e, r), i;
  }
  _c(t) {
    return new this.constructor(t);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(t) {
    const e = t.replace("#", "");
    function r(i, o) {
      return parseInt(e[i] + e[o || i], 16);
    }
    e.length < 6 ? (this.r = r(0), this.g = r(1), this.b = r(2), this.a = e[3] ? r(3) / 255 : 1) : (this.r = r(0, 1), this.g = r(2, 3), this.b = r(4, 5), this.a = e[6] ? r(6, 7) / 255 : 1);
  }
  fromHsl({
    h: t,
    s: e,
    l: r,
    a: i
  }) {
    if (this._h = t % 360, this._s = e, this._l = r, this.a = typeof i == "number" ? i : 1, e <= 0) {
      const g = h(r * 255);
      this.r = g, this.g = g, this.b = g;
    }
    let o = 0, s = 0, a = 0;
    const c = t / 60, u = (1 - Math.abs(2 * r - 1)) * e, l = u * (1 - Math.abs(c % 2 - 1));
    c >= 0 && c < 1 ? (o = u, s = l) : c >= 1 && c < 2 ? (o = l, s = u) : c >= 2 && c < 3 ? (s = u, a = l) : c >= 3 && c < 4 ? (s = l, a = u) : c >= 4 && c < 5 ? (o = l, a = u) : c >= 5 && c < 6 && (o = u, a = l);
    const f = r - u / 2;
    this.r = h((o + f) * 255), this.g = h((s + f) * 255), this.b = h((a + f) * 255);
  }
  fromHsv({
    h: t,
    s: e,
    v: r,
    a: i
  }) {
    this._h = t % 360, this._s = e, this._v = r, this.a = typeof i == "number" ? i : 1;
    const o = h(r * 255);
    if (this.r = o, this.g = o, this.b = o, e <= 0)
      return;
    const s = t / 60, a = Math.floor(s), c = s - a, u = h(r * (1 - e) * 255), l = h(r * (1 - e * c) * 255), f = h(r * (1 - e * (1 - c)) * 255);
    switch (a) {
      case 0:
        this.g = f, this.b = u;
        break;
      case 1:
        this.r = l, this.b = u;
        break;
      case 2:
        this.r = u, this.b = f;
        break;
      case 3:
        this.r = u, this.g = l;
        break;
      case 4:
        this.r = f, this.g = u;
        break;
      case 5:
      default:
        this.g = u, this.b = l;
        break;
    }
  }
  fromHsvString(t) {
    const e = O(t, D);
    this.fromHsv({
      h: e[0],
      s: e[1],
      v: e[2],
      a: e[3]
    });
  }
  fromHslString(t) {
    const e = O(t, D);
    this.fromHsl({
      h: e[0],
      s: e[1],
      l: e[2],
      a: e[3]
    });
  }
  fromRgbString(t) {
    const e = O(t, (r, i) => (
      // Convert percentage to number. e.g. 50% -> 128
      i.includes("%") ? h(r / 100 * 255) : r
    ));
    this.r = e[0], this.g = e[1], this.b = e[2], this.a = e[3];
  }
}
var _ = 2, B = 0.16, Ot = 0.05, Mt = 0.05, Ht = 0.15, Z = 5, tt = 4, Nt = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function W(n, t, e) {
  var r;
  return Math.round(n.h) >= 60 && Math.round(n.h) <= 240 ? r = e ? Math.round(n.h) - _ * t : Math.round(n.h) + _ * t : r = e ? Math.round(n.h) + _ * t : Math.round(n.h) - _ * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function z(n, t, e) {
  if (n.h === 0 && n.s === 0)
    return n.s;
  var r;
  return e ? r = n.s - B * t : t === tt ? r = n.s + B : r = n.s + Ot * t, r > 1 && (r = 1), e && t === Z && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Math.round(r * 100) / 100;
}
function V(n, t, e) {
  var r;
  return e ? r = n.v + Mt * t : r = n.v - Ht * t, r = Math.max(0, Math.min(1, r)), Math.round(r * 100) / 100;
}
function jt(n) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = [], r = new y(n), i = r.toHsv(), o = Z; o > 0; o -= 1) {
    var s = new y({
      h: W(i, o, !0),
      s: z(i, o, !0),
      v: V(i, o, !0)
    });
    e.push(s);
  }
  e.push(r);
  for (var a = 1; a <= tt; a += 1) {
    var c = new y({
      h: W(i, a),
      s: z(i, a),
      v: V(i, a)
    });
    e.push(c);
  }
  return t.theme === "dark" ? Nt.map(function(u) {
    var l = u.index, f = u.amount;
    return new y(t.backgroundColor || "#141414").mix(e[l], f).toHexString();
  }) : e.map(function(u) {
    return u.toHexString();
  });
}
var H = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
H.primary = H[5];
function F(n, t) {
  var e = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function m(n) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? F(Object(e), !0).forEach(function(r) {
      d(n, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : F(Object(e)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return n;
}
function Pt() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Rt(n, t) {
  if (!n)
    return !1;
  if (n.contains)
    return n.contains(t);
  for (var e = t; e; ) {
    if (e === n)
      return !0;
    e = e.parentNode;
  }
  return !1;
}
var q = "data-rc-order", K = "data-rc-priority", kt = "rc-util-key", N = /* @__PURE__ */ new Map();
function et() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = n.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : kt;
}
function R(n) {
  if (n.attachTo)
    return n.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function At(n) {
  return n === "queue" ? "prependQueue" : n ? "prepend" : "append";
}
function k(n) {
  return Array.from((N.get(n) || n).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function nt(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Pt())
    return null;
  var e = t.csp, r = t.prepend, i = t.priority, o = i === void 0 ? 0 : i, s = At(r), a = s === "prependQueue", c = document.createElement("style");
  c.setAttribute(q, s), a && o && c.setAttribute(K, "".concat(o)), e != null && e.nonce && (c.nonce = e == null ? void 0 : e.nonce), c.innerHTML = n;
  var u = R(t), l = u.firstChild;
  if (r) {
    if (a) {
      var f = (t.styles || k(u)).filter(function(g) {
        if (!["prepend", "prependQueue"].includes(g.getAttribute(q)))
          return !1;
        var w = Number(g.getAttribute(K) || 0);
        return o >= w;
      });
      if (f.length)
        return u.insertBefore(c, f[f.length - 1].nextSibling), c;
    }
    u.insertBefore(c, l);
  } else
    u.appendChild(c);
  return c;
}
function Et(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = R(t);
  return (t.styles || k(e)).find(function(r) {
    return r.getAttribute(et(t)) === n;
  });
}
function It(n, t) {
  var e = N.get(n);
  if (!e || !Rt(document, e)) {
    var r = nt("", t), i = r.parentNode;
    N.set(n, i), n.removeChild(r);
  }
}
function $t(n, t) {
  var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = R(e), i = k(r), o = m(m({}, e), {}, {
    styles: i
  });
  It(r, o);
  var s = Et(t, o);
  if (s) {
    var a, c;
    if ((a = o.csp) !== null && a !== void 0 && a.nonce && s.nonce !== ((c = o.csp) === null || c === void 0 ? void 0 : c.nonce)) {
      var u;
      s.nonce = (u = o.csp) === null || u === void 0 ? void 0 : u.nonce;
    }
    return s.innerHTML !== n && (s.innerHTML = n), s;
  }
  var l = nt(n, o);
  return l.setAttribute(et(o), t), l;
}
function rt(n) {
  var t;
  return n == null || (t = n.getRootNode) === null || t === void 0 ? void 0 : t.call(n);
}
function Lt(n) {
  return rt(n) instanceof ShadowRoot;
}
function Dt(n) {
  return Lt(n) ? rt(n) : null;
}
var j = {}, A = [], Bt = function(t) {
  A.push(t);
};
function Wt(n, t) {
  if (process.env.NODE_ENV !== "production" && !n && console !== void 0) {
    var e = A.reduce(function(r, i) {
      return i(r ?? "", "warning");
    }, t);
    e && console.error("Warning: ".concat(e));
  }
}
function zt(n, t) {
  if (process.env.NODE_ENV !== "production" && !n && console !== void 0) {
    var e = A.reduce(function(r, i) {
      return i(r ?? "", "note");
    }, t);
    e && console.warn("Note: ".concat(e));
  }
}
function Vt() {
  j = {};
}
function it(n, t, e) {
  !t && !j[e] && (n(!1, e), j[e] = !0);
}
function S(n, t) {
  it(Wt, n, t);
}
function Ft(n, t) {
  it(zt, n, t);
}
S.preMessage = Bt;
S.resetWarned = Vt;
S.noteOnce = Ft;
function qt(n) {
  return n.replace(/-(.)/g, function(t, e) {
    return e.toUpperCase();
  });
}
function Kt(n, t) {
  S(n, "[@ant-design/icons] ".concat(t));
}
function Q(n) {
  return b(n) === "object" && typeof n.name == "string" && typeof n.theme == "string" && (b(n.icon) === "object" || typeof n.icon == "function");
}
function G() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(n).reduce(function(t, e) {
    var r = n[e];
    switch (e) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[e], t[qt(e)] = r;
    }
    return t;
  }, {});
}
function P(n, t, e) {
  return e ? /* @__PURE__ */ $.createElement(n.tag, m(m({
    key: t
  }, G(n.attrs)), e), (n.children || []).map(function(r, i) {
    return P(r, "".concat(t, "-").concat(n.tag, "-").concat(i));
  })) : /* @__PURE__ */ $.createElement(n.tag, m({
    key: t
  }, G(n.attrs)), (n.children || []).map(function(r, i) {
    return P(r, "".concat(t, "-").concat(n.tag, "-").concat(i));
  }));
}
function ot(n) {
  return jt(n)[0];
}
function st(n) {
  return n ? Array.isArray(n) ? n : [n] : [];
}
var Qt = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Gt = function(t) {
  var e = gt(U), r = e.csp, i = e.prefixCls, o = e.layer, s = Qt;
  i && (s = s.replace(/anticon/g, i)), o && (s = "@layer ".concat(o, ` {
`).concat(s, `
}`)), mt(function() {
    var a = t.current, c = Dt(a);
    $t(s, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: c
    });
  }, []);
}, Ut = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], x = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Yt(n) {
  var t = n.primaryColor, e = n.secondaryColor;
  x.primaryColor = t, x.secondaryColor = e || ot(t), x.calculated = !!e;
}
function Jt() {
  return m({}, x);
}
var p = function(t) {
  var e = t.icon, r = t.className, i = t.onClick, o = t.style, s = t.primaryColor, a = t.secondaryColor, c = J(t, Ut), u = C.useRef(), l = x;
  if (s && (l = {
    primaryColor: s,
    secondaryColor: a || ot(s)
  }), Gt(u), Kt(Q(e), "icon should be icon definiton, but got ".concat(e)), !Q(e))
    return null;
  var f = e;
  return f && typeof f.icon == "function" && (f = m(m({}, f), {}, {
    icon: f.icon(l.primaryColor, l.secondaryColor)
  })), P(f.icon, "svg-".concat(f.name), m(m({
    className: r,
    onClick: i,
    style: o,
    "data-icon": f.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, c), {}, {
    ref: u
  }));
};
p.displayName = "IconReact";
p.getTwoToneColors = Jt;
p.setTwoToneColors = Yt;
function at(n) {
  var t = st(n), e = Y(t, 2), r = e[0], i = e[1];
  return p.setTwoToneColors({
    primaryColor: r,
    secondaryColor: i
  });
}
function Xt() {
  var n = p.getTwoToneColors();
  return n.calculated ? [n.primaryColor, n.secondaryColor] : n.primaryColor;
}
var Zt = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
at(H.primary);
var E = /* @__PURE__ */ C.forwardRef(function(n, t) {
  var e = n.className, r = n.icon, i = n.spin, o = n.rotate, s = n.tabIndex, a = n.onClick, c = n.twoToneColor, u = J(n, Zt), l = C.useContext(U), f = l.prefixCls, g = f === void 0 ? "anticon" : f, w = l.rootClassName, ct = Tt(w, g, d(d({}, "".concat(g, "-").concat(r.name), !!r.name), "".concat(g, "-spin"), !!i || r.name === "loading"), e), T = s;
  T === void 0 && a && (T = -1);
  var ut = o ? {
    msTransform: "rotate(".concat(o, "deg)"),
    transform: "rotate(".concat(o, "deg)")
  } : void 0, lt = st(c), I = Y(lt, 2), ft = I[0], ht = I[1];
  return /* @__PURE__ */ C.createElement("span", M({
    role: "img",
    "aria-label": r.name
  }, u, {
    ref: t,
    tabIndex: T,
    onClick: a,
    className: ct
  }), /* @__PURE__ */ C.createElement(p, {
    icon: r,
    primaryColor: ft,
    secondaryColor: ht,
    style: ut
  }));
});
E.displayName = "AntdIcon";
E.getTwoToneColor = Xt;
E.setTwoToneColor = at;
export {
  E as I,
  M as _,
  b as a,
  d as b,
  J as c,
  m as d,
  Y as e,
  Pt as f,
  _t as t,
  S as w
};
